import { gql } from '@apollo/client';

export const DELETE_ANIMAL = gql`
  mutation deleteAnimal($id: ID!) {
    deleteAnimal(id: $id)
  }
`;
